<mat-toolbar class="backcolor-primary flex-row" color="mat-toolbar">
  <mat-toolbar-row class="flex-row" id="mainbar">
    <img class="header-logo" [style.margin-left]="logoMarginLeft()" src="assets/hch_logo.png">
    <img [style.width]="logoWidth()" [style.margin-right]="logoMarginRight()" [style.opacity]="logoOpacity()"
      src="assets/hch_brand.png">
    <div class="flex-force flex-fill flex-col header-title">
      <span class="font-title">{{ appTitle }}</span>
      @if (showChips()) {
      <mat-chip-grid #chipGrid class="flex-fill flex-row chip-grid">
        <mat-chip-row [routerLink]="[ appStateService.navigationMain() ]" class="chip font-text backcolor-primary">{{
          appStateService.navigationPlangebiet() }}</mat-chip-row>
        @for (segment of appStateService.navigationSegements(); track $index) {
        <mat-chip-row [routerLink]="[ segment.url ]" class="chip font-header backcolor-primary">{{ segment.name
          }}</mat-chip-row>
        }
        <input [matChipInputFor]="chipGrid" />
      </mat-chip-grid>
      }
    </div>
    @if (appStateService.navigationAssistentShow()) {
    <app-assistent-bar class="header-row-item"></app-assistent-bar>
    }
    <button mat-button class="button-small-icon button-minwidth-36px" matTooltip="Menü" [matMenuTriggerFor]="menu">
      <span color="secondary"
        class="material-symbols-outlined icon-24px icon-margin-top-10px color-secondary">menu</span>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
<mat-menu #menu x-position="before">
  <button mat-menu-item (click)="toggleTheme()">
    <mat-icon>looks</mat-icon>Theme wechseln
  </button>
  <button mat-menu-item (click)="openHandbuch()">
    <mat-icon>help</mat-icon>Handbuch
  </button>
    <button mat-menu-item (click)="openHelp(1)">
    <mat-icon>help</mat-icon>Fachliche Erläuterungen
  </button>
  <button mat-menu-item (click)="openHelp(2)">
    <mat-icon>help</mat-icon>Technische Hinweise
  </button>
  <button *ngIf="isLoggedin()" mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>Logout
  </button>
  <button *ngIf="!isLoggedin()" mat-menu-item (click)="login()">
    <mat-icon>login</mat-icon>Login
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item disabled>
    <mat-icon>account_circle</mat-icon>{{ msalService.instance.getActiveAccount()?.username}}
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item disabled>
    <mat-icon>account_circle</mat-icon>{{ userService.userInfo()?.userName }}
  </button>
  <button mat-menu-item disabled>
    <mat-icon>security</mat-icon>{{ userService.userInfo()?.rollenInfo}}
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item disabled>
    <mat-icon>info</mat-icon>{{ appVersion }}
  </button>
  <mat-divider></mat-divider>
  <mat-menu #styleMenu="matMenu">
  <button mat-menu-item (click)="setStyle('default')">
      <mat-icon>style</mat-icon>Standard
    </button>
    <button mat-menu-item (click)="setStyle('flat')">
      <mat-icon>style</mat-icon>Flach
    </button>
    <button mat-menu-item (click)="setStyle('halfflat')">
      <mat-icon>style</mat-icon>Schmal
    </button>
  </mat-menu>
    <button mat-menu-item [matMenuTriggerFor]="styleMenu">
      <mat-icon>style</mat-icon>Styles
    </button>
  <mat-divider *ngIf="isTestMode()"></mat-divider>
  <mat-menu #testRollen="matMenu">
    <ng-container *ngFor="let rolle of userService.userInfo()?.alleRollen">
      <button mat-menu-item (click)="setTestRole(rolle)">
        <mat-icon>{{getIconName(rolle)}}</mat-icon>{{rolle}}
      </button>
    </ng-container>
    <button *ngIf="isTestMode()" mat-menu-item (click)="setTestRole(null)">
      <mat-icon>logout</mat-icon>Zurücksetzen
    </button>
  </mat-menu>
  <button *ngIf="isTestMode()" mat-menu-item [matMenuTriggerFor]="testRollen">
    <mat-icon>build</mat-icon>Testrollen
  </button>
   <mat-divider *ngIf="isTestMode()"></mat-divider>
   <mat-menu #testMenu="matMenu">
      <button mat-menu-item (click)="ExecuteTest('DeleteToken')">
      Delete Token
      </button>
      <button mat-menu-item (click)="ExecuteTest('NewToken')">
      New Token
      </button>
      <button mat-menu-item (click)="ExecuteTest('graphmail')">
      Graph-Mail
      </button>
   </mat-menu>
  <button *ngIf="isTestMode()" mat-menu-item [matMenuTriggerFor]="testMenu">
    <mat-icon>build</mat-icon>Tests
   </button>

</mat-menu>